type TenantScopedArtifact = {
  tenant_id?: string | null;
};

export function shouldResetRoiTenantState(
  previousTenantId: string | null | undefined,
  nextTenantId: string | null | undefined,
): boolean {
  return previousTenantId !== nextTenantId;
}

export function isTenantScopedRoiArtifact<T extends TenantScopedArtifact>(
  artifact: T | null | undefined,
  tenantId: string | null | undefined,
): artifact is T {
  return Boolean(artifact && tenantId && artifact.tenant_id === tenantId);
}

export function findTenantScopedRoiArtifact<T extends TenantScopedArtifact>(
  artifacts: T[] | null | undefined,
  tenantId: string | null | undefined,
): T | null {
  return artifacts?.find((artifact) => isTenantScopedRoiArtifact(artifact, tenantId)) ?? null;
}
